import EY_S from "../../../../images/EY_S.png";
import RK_B from "../../../../images/RK_B.png";
import RK_W from "../../../../images/RK_W.png";
import KT_B from "../../../../images/KT_B.png";
import KT_W from "../../../../images/KT_W.png";
import BP_B from "../../../../images/BP_B.png";
import BP_W from "../../../../images/BP_W.png";
import QN_B from "../../../../images/QN_B.png";
import QN_W from "../../../../images/QN_W.png";
import KG_B from "../../../../images/KG_B.png";
import KG_W from "../../../../images/KG_W.png";
import PN_B from "../../../../images/PN_B.png";
import PN_W from "../../../../images/PN_W.png";

export function renderCaptureHolder() {
	//capture holder render
	for (let a = 1; a <= 8; a++) {
		let IDB01 = document.getElementById(`P${a}0`); // Captured Black: P10, P20, P30, P40, P50, P60, P70, P80
		let IDB02 = document.getElementById(`P${a}9`); // Captured Black: P19, P29, P39, P49, P59, P69, P79, P89
		let IDW01 = document.getElementById(`P0${a}`); // Captured White: P01, P02, P03, P04, P05, P06, P07, P08
		let IDW02 = document.getElementById(`P9${a}`); // Captured White: P91, P92, P93, P94, P95, P96, P97, P98

		IDW01.src = IDW02.src = IDB01.src = IDB02.src = EY_S;
		// IDW01.style.height = IDW02.style.height = IDB01.style.height = IDB02.style.height = "5vh";
		// IDW01.style.width = IDW02.style.width = IDB01.style.width = IDB02.style.width = "5vh";
		IDW01.style.height = IDW02.style.height = IDB01.style.height = IDB02.style.height = "2.5vw";
		IDW01.style.width = IDW02.style.width = IDB01.style.width = IDB02.style.width = "2.5vw";

		IDW01.style.backgroundColor = IDW02.style.backgroundColor = "rgb(20, 20, 20)";
		IDB01.style.backgroundColor = IDB02.style.backgroundColor = "rgb(235, 235, 235)";
		// IDB01.style.backgroundColor = IDB02.style.backgroundColor = "rgb(255, 255, 255)";
	}
}

export function renderBoardAndPieces(whitePosition, blackPosition, whitePiece, blackPiece) {
	//Render the board color (alternating black and white)
	for (let a = 1; a <= 8; a++) {
		for (let b = 1; b <= 8; b++) {
			const piece = document.getElementById(`P${b}${a}`);
			piece.src = EY_S; // empty image to hold the box
			// piece.style.height = "10vh";
			// piece.style.width = "10vh";
			piece.style.height = "5.2vw";
			piece.style.width = "5.2vw";

			// black board
			// if ((a + b) % 2 === 0) piece.style.backgroundColor = "rgb(100, 100, 100)";
			// else piece.style.backgroundColor = "rgb(150, 150, 150)";
			if ((a + b) % 2 === 0) piece.style.backgroundColor = "rgb(75, 75, 75)";
			else piece.style.backgroundColor = "rgb(150, 150, 150)";
			// if ((a + b) % 2 === 0) piece.style.backgroundColor = "rgb(75, 75, 75)";
			// else piece.style.backgroundColor = "rgb(180, 180, 180)";
			// white board
		}
	}

	//Render the pieces in its position based on blackPosition and whitePosition array
	for (let a = 0; a < 16; a++) {
		document.getElementById(`P${blackPosition[a]}`).src = PieceImage(blackPiece[a]);
		document.getElementById(`P${whitePosition[a]}`).src = PieceImage(whitePiece[a]);
	}
}

function PieceImage(piece) {
	switch (piece) {
		case "RK_B":
			return RK_B;
		case "RK_W":
			return RK_W;
		case "KT_B":
			return KT_B;
		case "KT_W":
			return KT_W;
		case "BP_B":
			return BP_B;
		case "BP_W":
			return BP_W;
		case "QN_B":
			return QN_B;
		case "QN_W":
			return QN_W;
		case "KG_B":
			return KG_B;
		case "KG_W":
			return KG_W;
		case "PN_B":
			return PN_B;
		case "PN_W":
			return PN_W;
	}
}
